import "alpinejs";

// import loadMore from "./imports/loadmore.js";
import parallax from "./imports/parallax.js";



document.addEventListener("DOMContentLoaded", function() {
    // TODO: does not work with plugin custom order
    // loadMore.init();
    
    parallax.init();
});

